import { reducer } from './redux-reducer';
import { selectors } from './selectors';
import { actions } from './constants';
import * as actionCreators from './redux-action-creators';

const landscapeStateReducers = { landscapeState: reducer };

// VMS
export { landscapeStateReducers, selectors, actionCreators, actions };
